import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { Icon } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

import agent from '../../app/api/agent';
import { convertToCSV, exportToCsv } from './csvFunction';
import MetaDataModal from './MetaDataModal';
import { CRMService } from '../../app/stores/CRMStore/service';
import { defectOrder } from '../../app/models/Restoration';
interface Props {
  tableData: any;
  tableName: string;
  fileName?:string
  name?: string;
}
function DynamicTableCSVReport({ tableData, tableName, fileName, name = '' }: Props) {
  const {
    reportStore,
    userStore: { user },
    dashboardStore:{getMenuCount,dashboard}
  } = useStore();

  const [downloadData, setDownloadData] = useState<any>([]);
  const [totalCountData, setTotalCountData] = useState(0);
  const [loader,setLoader] = useState(false);
  const pageSize = 25;

  const handleLoadMetaDataCount = async () => {
    // loadTotalMetaDataCount()
    try {
      setLoader(true);
      if (tableName === 'Pc_Process') {
        const flattenedArray = tableData.reduce(
          (acc: any, curr: any) => acc.concat(curr),
          [],
        );
        exportToCsv(
          'CAT-A Project Progress Tracker Report.csv',
          convertToCSV(flattenedArray),
        );
        return;
      }
      if(user?.customerName === 'PCPLCRM'){
        const countdata = await CRMService.ItAssetInventoryItemsSearchCount('');
        const response:any =  tableName === 'IT Asset List' ? await CRMService.ItAssetInventoryItemsSearch(1,'',countdata.data) :  await agent.Activities.listPagination({
          pageNo: 1,
          pageSize: getMenuCount.inventoryCount,
          searchDate: Object.keys(dashboard.searchfilterparams).length === 0 ? '' : JSON.stringify(dashboard.searchfilterparams)
        })
        const getAssetByMakeOrModelNo = (response:any[]) =>{
          return response.map(e => ({
             ...e,
             title: e.title?.split('~')[0]?.split('-')[0].trim() || ''
            //  title : e.make_Or_Model_No ? e.make_Or_Model_No : e.title
           }))
         }
         const data =  getAssetByMakeOrModelNo(tableName === 'IT Asset List' ? response?.data : response);
         exportToCsv(`${tableName}.csv`, convertToCSV(data))
         setLoader(false);
         return;
      }
      const countResponse = await agent.Reports.loadTotalMetaDataCount();
      // this.metaDataCount = parseInt(countResponse.slice(20))
      let countdata = parseInt(countResponse.slice(20));
      setTotalCountData(parseInt(countResponse.slice(20)));
      if (countdata <= 25) {
        let text = localStorage.getItem(`${tableName}`)!;
        if (text.includes(',')) {
          const countResponse2 = await agent.Reports.reportsWithPaginationPost(
            1,
            pageSize,
            text?.split(','),
          );
          const data =  countResponse2?.data.replaceAll('}}', '}');
          const parsedData = JSON.parse(data);
          if (
            (tableName === 'AssetTable' ||
              tableName === 'ReportsTable' ||
              tableName === 'SmartTracker') &&
            user?.customerName === 'LVPCMS'
          ) {
            let newArr = parsedData.filter((x: any) => {
              return x.type !== 'Film Festival';
            });
            exportToCsv('metadatareport.csv', convertToCSV(newArr));
          } else if (
            tableName === 'ProjectReport' &&
            user?.customerName === 'LVPCMS'
          ) {
            let newArr = parsedData.filter((x: any) => {
              return x.type === 'Film Festival';
            });
            exportToCsv('metadatareport.csv', convertToCSV(newArr));
          } else if (name === 'OpratorPerformance') {
            const flattenedArray = tableData.reduce(
              (acc: any, curr: any) => acc.concat(curr),
              [],
            );
            exportToCsv('metadatareport.csv', convertToCSV(flattenedArray));
          } else if(name === 'OperatorPerformanceNFAI' || name === 'DefectReportNFAI'){
                  const flattenedArray = tableData.reduce(
              (acc: any, curr: any) => acc.concat(curr),
              []
            );

            // Reorder keys for each row
            const orderedData = flattenedArray.map((row: any) => {
              const sortedRow: any = {};
              defectOrder.forEach((key) => {
                sortedRow[key] = row[key] ?? "";  // keep empty if not present
              });
              return sortedRow;
            });

            // Convert to CSV
            const csvData = convertToCSV(orderedData);
            exportToCsv(`${fileName}.csv`, csvData);

         } else {
            exportToCsv('metadatareport.csv', convertToCSV(parsedData));
          }
        } else {
          const countResponse2 = await agent.Reports.reportsWithPaginationPost(
            1,
            pageSize,
            [text],
          );
          const parsedData = JSON.parse(countResponse2.data);
          if (
            (tableName === 'AssetTable' ||
              tableName === 'ReportsTable' ||
              tableName === 'SmartTracker') &&
            user?.customerName === 'LVPCMS'
          ) {
            let newArr = parsedData.filter((x: any) => {
              return x.type !== 'Film Festival';
            });
            exportToCsv('metadatareport.csv', convertToCSV(newArr));
          } else if (
            tableName === 'ProjectReport' &&
            user?.customerName === 'LVPCMS'
          ) {
            let newArr = parsedData.filter((x: any) => {
              return x.type === 'Film Festival';
            });
            exportToCsv('metadatareport.csv', convertToCSV(newArr));
          } else {
            exportToCsv('metadatareport.csv', convertToCSV(parsedData));
          }
        }
      } else {
        if(name === 'OperatorPerformanceNFAI' || name === 'DefectReportNFAI'){
        const flattenedArray = tableData.reduce(
          (acc: any, curr: any) => acc.concat(curr),
          [],
        );
        const altData = convertToCSV(flattenedArray)
        exportToCsv(`${fileName}.csv`, altData);
         }
        else if (name === 'OpratorPerformance') {
          const flattenedArray = tableData.reduce(
            (acc: any, curr: any) => acc.concat(curr),
            [],
          );
          exportToCsv('metadatareport.csv', convertToCSV(flattenedArray));
        } else {
          reportStore.setOpenMetaDataReportModal(true);
        }
      }
      setLoader(false);
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (tableName === 'AllocateUser') {
      tableData.forEach(function (data: any) {
        delete data.assignedUsers;
        delete data.clearedon;
        delete data.calculated_category;
        delete data.digitalization_priority;
        delete data.inwards;
        delete data.isActive;
        delete data.isDeleted;
        delete data.isDelivery;
        delete data.isHost;
        delete data.isReceiving;
        delete data.isReceivingOrder;
        delete data.itemCreatedBy;
      });
    }
    setDownloadData(tableData);
    // eslint-disable-next-line
  }, [tableData]);

  useEffect(() => {
    if (fileName) {
      const element: HTMLElement | null = document.getElementById("fileName");
      if (element) {
        element.setAttribute("download", `${fileName}.csv`);
      }
    }
  }, [fileName]);
  

  return (
    <div>
      {reportStore.openMetaDataReportModal && (
        <MetaDataModal totalCountData={totalCountData} tableName={tableName} />
      )}
      {tableName !== 'AssetTable' &&
      tableName !== 'InventoryReportsTable' &&
      tableName !== 'ReportsTable' &&
      tableName !== 'SmartTracker' &&
      tableName !== 'Pc_Process' &&
      tableName !== 'IT Asset List' &&
      tableName !== 'OperatorPerformanceNFAI' &&
      name !== 'DefectReportNFAI' ? (
        <CSVLink data={downloadData} id={'fileName'} filename={tableName}>
          <Icon
            corner="bottom right"
            size="large"
            circular
            inverted
            color="teal"
            name="download"
          />
        </CSVLink>
      ) : (
        <>
          <Icon
            corner="bottom right"
            size="large"
            circular
            inverted
            color="teal"
            name="download"
            onClick={handleLoadMetaDataCount}
            loading ={loader}
          />
        </>
      )}
    </div>
  );
}

export default observer(DynamicTableCSVReport);
